


$(document).on("click", ".product-form__submit", function(event){
  const formForUpdate = $('.shopify-product-form');
  let sponsor_dog_value = formForUpdate.find('input[name="properties[Sponsored dog]"]').val();
  let subscription_value = jQuery('.appstle_sub_widget input[name=selling_plan]:checked').val();

  
  if((subscription_value != "" && sponsor_dog_value == "") || (subscription_value != "" && typeof sponsor_dog_value == "undefined")){
    const is_popup_displayed = document.getElementById("sponsor_dog_waning_popup_wrapp").getAttribute("data-displayed");
    const is_popup_skip = document.getElementById("sponsor_dog_waning_popup_wrapp").getAttribute("data-skipPopup");
    if(is_popup_skip == "false"){
    // if(is_popup_displayed == "0" || is_popup_displayed == 0){
      
      document.querySelector("#sponsor_dog_waning_popup_wrapp .sd-product-title-save-select").classList.add("hidden");
      document.querySelector("#sponsor_dog_waning_popup_wrapp .sd-product-title-select").classList.remove("hidden");
      
      document.getElementById("sponsor_dog_waning_popup_wrapp").style.display = "flex";
      document.getElementById("sponsor_dog_waning_popup_wrapp").setAttribute("data-displayed", 1);
      document.querySelector("#sponsor_dog_waning_popup_wrapp #sponsor_dog_warning_popup_select").setAttribute("data-scollTo", "dog_section");
      
      window._submitClicked = this;
      event.preventDefault();
    }
  }
  document.getElementById("sponsor_dog_waning_popup_wrapp").setAttribute("data-skipPopup", false);
  const redirectUrl = $(this).attr("data-redirect-url");
  if (redirectUrl) {
    event.preventDefault(); // Prevent default form submission
    window.location.href = redirectUrl; // Redirect to the URL
  }
});


  /*
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-form__submit").forEach((button) => {
    button.addEventListener("click", (event) => {
      // show warning to select sponsored dog before Add to cart
      const formForUpdate = $('.shopify-product-form');
      let inputToUpdate = formForUpdate.find('input[name="properties[Sponsored dog]"]').val();
      if(typeof inputToUpdate == "undefined" || inputToUpdate == ""){
        const is_popup_displayed = document.getElementById("sponsor_dog_waning_popup_wrapp").getAttribute("data-displayed");
        // if(is_popup_displayed == "0" || is_popup_displayed == 0){
          document.getElementById("sponsor_dog_waning_popup_wrapp").style.display = "flex";
          document.getElementById("sponsor_dog_waning_popup_wrapp").setAttribute("data-displayed", 1);
          event.preventDefault();        
        // }
      }
      
      const redirectUrl = button.getAttribute("data-redirect-url");
      if (redirectUrl) {
        event.preventDefault(); // Prevent default form submission
        window.location.href = redirectUrl; // Redirect to the URL
      }
    });
  });
});
  */



// click for select dog btn from row
$(document).on("click", "#select_dog_btn", function (e) {
  updateSelection($(this), $(this).attr("data-dog-value"));
});

// click for select dog btn from modal
$(document).on("click", "#select_dog_from_modal", function (e) {
  updateSelection($(this), $(this).attr("data-dog-value"));
});

// click for show dog profile modal
$(document).on("click", "#learn_more_dog", function (e) {
  e.preventDefault();
  const modalTargetSelector = $(this).attr("data-modal-target");
  const modalToShow = $(modalTargetSelector);
  if (modalToShow) modalToShow.css("display", "flex");
});

// click for close dog profile modal
$(document).on("click", "#clsoe_learn_more_dog_modal", function (e) {
  e.preventDefault();
  $(".dog-modal").css("display", "none");
});

// for upadte hidden input of god name
function updateSelection(curr_elem, selectedValue) {
  if(jQuery('.appstle_sub_widget input[name=selling_plan]:checked').val() != "") {
    const formForUpdate = $('.shopify-product-form');
    let inputToUpdate = null;
    if (formForUpdate) {
      inputToUpdate = formForUpdate.find('input[name="properties[Sponsored dog]"]');
      if (inputToUpdate.length) {
        inputToUpdate.val(selectedValue);
      } else {
        const sponsor_input_hidden = "<input id='sponsored_god_files' type='hidden' name='properties[Sponsored dog]' value='" + selectedValue + "'>";
        formForUpdate.append(sponsor_input_hidden);
      }
    }

    if (inputToUpdate) {
      inputToUpdate.val(selectedValue);
    }

    const dogRows = $(".dog-row[data-dog-name]");
    dogRows.removeClass("selected");
    $(`.dog-row[data-dog-name="${selectedValue}"]`).addClass("selected");

    let subscription_value = jQuery('.appstle_sub_widget input[name=selling_plan]:checked').val();

    if(subscription_value != ""){
      const add_to_cart_btn = document.querySelector(".product__info-container product-form .product-form__submit.button")
      add_to_cart_btn.click();
      const topSponsorDogElem = add_to_cart_btn.offsetTop-200;
      window.scrollTo({top: topSponsorDogElem, behavior: 'smooth' });
    }
    
    /*
    if (window._submitClicked) {
      $(window._submitClicked).click();
      
      const topSponsorDogElem = window._submitClicked.offsetTop-200;
      window.scrollTo({top: topSponsorDogElem, behavior: 'smooth' });
      
      delete window._submitClicked
    }
    */

    const dogRowsBts = $(".select-dog-btn[data-dog-value]");
    dogRowsBts.text("Select");
    $(`.dog-row[data-dog-name="${selectedValue}"].selected`).find(".select-dog-btn").text("Selected");
  }else{
    document.querySelector("#sponsor_dog_waning_popup_wrapp .sd-product-title-save-select").classList.remove("hidden");
    document.querySelector("#sponsor_dog_waning_popup_wrapp .sd-product-title-select").classList.add("hidden");
    
    document.getElementById("sponsor_dog_waning_popup_wrapp").style.display = "flex";
    document.getElementById("sponsor_dog_waning_popup_wrapp").setAttribute("data-displayed", 1);
    document.querySelector("#sponsor_dog_waning_popup_wrapp #sponsor_dog_warning_popup_select").setAttribute("data-scollTo", "subscription_section");
  }
  $(".dog-modal").css("display", "none");
}



$(document).on("change", ".appstle_subscription_wrapper input[name='selling_plan']", function(){
  if($(this).val() == ""){
    $(".dog-row .select-dog-btn").text("Select")
    $(`.dog-row`).removeClass("selected");
    const formForUpdate = $('.shopify-product-form');
    inputToUpdate = formForUpdate.find('input[name="properties[Sponsored dog]"]').remove();
  }
});
$(document).on("change", ".appstle_sub_widget input[name=selling_plan_radio]", function(){
    var topSponsorDogElem = document.querySelector('.sponsor-section-wrapper').offsetTop;
    window.scrollTo({top: topSponsorDogElem, behavior: 'smooth' });
});

/*
document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function() {
    setTimeout(function(){
      console.log("test timeout plan selected123456789")
        const getClickElem = document.querySelector(".appstleLoyaltyTable .appstle_loyalty_title");
      console.log("test timeout inside plan selected123456789", getClickElem)
      if(getClickElem){
      console.log("test timeout inside if plan selected123456789", getClickElem)
        addClickForRewards(getClickElem);
      }
    }, 700);
});
*/

/*
$(document).on("change", '.appstle_sub_widget input[name=selling_plan]', function(e) {
  console.log("changed")
  let appstleCount = 0;
  const timer = setInterval(() => {
    appstleCount++;
    const titleEl = document.querySelector(".appstleLoyaltyTable .appstle_loyalty_title");
    if (appstleCount > 10 || titleEl !== null) {
      clearInterval(timer);
      if (titleEl) {
        setTimeout(function(){
          addClickForRewards(document.querySelector(".appstleLoyaltyTable .appstle_loyalty_title"));
        }, 700)
      }
    }
  }, 700);
})
*/



document.addEventListener('AppstleSubscription:SubscriptionWidget:widgetInitialised', function() {
  let appstleCount = 0;
  const timer = setInterval(() => {
    appstleCount++;
    const titleEl = document.querySelector(".appstleLoyaltyTable .appstle_loyalty_title");
    if (appstleCount > 15 || titleEl !== null) {
      clearInterval(timer);
      if (titleEl) {
        setTimeout(function(){
          addClickForRewards(".appstleLoyaltyTable .appstle_loyalty_title");
        }, 700)
      }
    }
  }, 700);
});

/*
document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function() {
    console.log('selling plan', jQuery('.appstle_sub_widget input[name=selling_plan]:checked').val());
    let appstleCount = 0;
  const timer = setInterval(() => {
    appstleCount++;
    const titleEl = document.querySelector(".appstleLoyaltyTable .appstle_loyalty_title");
    if (appstleCount > 15 || titleEl !== null) {
      clearInterval(timer);
      if (titleEl) {
        setTimeout(function(){
        console.log("titleEltitleEltitleEltitleEltitleEl--------------------- ok inside if 3", $(".appstleLoyaltyTable .appstle_loyalty_title"))
          addClickForRewards(".appstleLoyaltyTable .appstle_loyalty_title");
        }, 700)
      }
    }
  }, 700);
});
*/

function addClickForRewards(clickElem) {
  // $(clickElem).off("click").on("click", function(e) {
  $(document).on("click", clickElem, function(e) {
    const rewardElem = $(this).parent().find("table");
    // console.log("1111111111111 rewardElem", rewardElem)
    if (rewardElem.length) {
      rewardElem.toggleClass("custom_show_rewards");
      // console.log("111111111111111", rewardElem.css("display"));
      // if(rewardElem.css("display") == "none"){
      //   rewardElem.css("display", "");
      // }else{
      //   rewardElem.css("display", "none");
      // }
    }
  });
}



$(document).on("click", "#sponsor_dog_warning_popup_close", function(){
  document.getElementById('sponsor_dog_waning_popup_wrapp').style.display = 'none';

  if (window._submitClicked) {
    document.getElementById('sponsor_dog_waning_popup_wrapp').setAttribute("data-skipPopup", true);
    // $(window._submitClicked).click();
    // delete window._submitClicked
  }
  
  const subscription_value = jQuery('.appstle_sub_widget input[name=selling_plan]:checked').val();
  if(subscription_value != ""){
    const add_to_cart_btn = document.querySelector(".product__info-container product-form .product-form__submit.button")
    add_to_cart_btn.click();
    const topSponsorDogElem = add_to_cart_btn.offsetTop-200;
    window.scrollTo({top: topSponsorDogElem, behavior: 'smooth' });
  }
});

$(document).on("click", "#sponsor_dog_warning_popup_select", function(){
  const scroll_to = $(this).attr("data-scollTo");
  document.getElementById('sponsor_dog_waning_popup_wrapp').style.display = 'none';
  if(scroll_to == "dog_section"){
    var topSponsorDogElem = document.querySelector('.sponsor-section-wrapper').offsetTop;
    window.scrollTo({top: topSponsorDogElem, behavior: 'smooth' });
  }else{
    if(document.querySelector(".shopify-section-header-sticky").offsetHeight){
      var topSponsorDogElem = document.querySelector('.appstle_sub_widget').offsetTop - document.querySelector(".shopify-section-header-sticky").offsetHeight;
      window.scrollTo({top: topSponsorDogElem, behavior: 'smooth' });
    }else{
      var topSponsorDogElem = document.querySelector('.appstle_sub_widget').offsetTop;
      window.scrollTo({top: topSponsorDogElem, behavior: 'smooth' });
    }
  }
});
